// extracted by mini-css-extract-plugin
module.exports = {"head":"StoryItem_head__2As3w","user":"StoryItem_user__10FeH","name":"StoryItem_name__3fWel","buttons":"StoryItem_buttons__3GN9I"};